const set = require('regenerate')(0x205A, 0x205D, 0x2E31, 0x2E41);
set.addRange(0x10C80, 0x10CB2).addRange(0x10CC0, 0x10CF2).addRange(0x10CFA, 0x10CFF);
exports.characters = set;
